import { getIconProps, type IconProps } from '#types'

/**
 * Coach icon — whistle on a lanyard.
 *
 * Used for instructor / coaching surfaces (Lessons nav, instructor avatars
 * and empty states).
 *
 * @example
 * ```tsx
 * <CoachIcon className="size-5" />
 * ```
 */
export function CoachIcon({ strokeWidth = 2, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 35 34.9943">
      <path
        d="M27.3993 10.8973C24.6418 9.86121 21.2139 8.41927 17.4993 8.41927C13.7847 8.41927 10.3568 9.86121 7.59928 10.8973"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M8.09428 9.25L7.65671 7.73822C7.02984 4.13896 11.6149 1 17.4993 1C23.3836 1 27.9687 4.13896 27.3419 7.73822L26.9043 9.25"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 10.8971V13.7437C9.25 16.7025 10.7705 19.4444 13.2554 20.9667L14.1043 21.4868C16.1944 22.7672 18.8056 22.7672 20.8957 21.4868L21.7446 20.9668C24.2295 19.4444 25.75 16.7025 25.75 13.7437V10.8971"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M22.45 20.7943L24.1 25.7443M24.1 25.7443L21.8414 27.7167C19.7726 29.5235 18.7381 30.4269 17.5 30.4269C16.2619 30.4269 15.2274 29.5235 13.1586 27.7167L10.9 25.7443M24.1 25.7443L26.9613 26.698C28.6081 27.247 29.4315 27.5214 30.1625 27.9457C30.878 28.3611 31.527 28.8816 32.0876 29.49C32.6603 30.1115 34 32.3443 34 33.9943M12.55 20.7943L10.9 25.7443M10.9 25.7443L8.03867 26.698C6.39187 27.247 5.56847 27.5214 4.83753 27.9457C4.12202 28.3611 3.47305 28.8816 2.9124 29.49C2.33966 30.1115 1 32.3443 1 33.9943"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
